
import { Component, Vue } from 'vue-property-decorator';

import { TransactionsSummaryList } from '@/modules/transaction/components/TransactionsSummaryList';
import { HandleSection } from '@/modules/trade/components/HandleSection';

import { getMovements, TradeMovements } from '@/modules/trade/services/account';
import { ApolloQueryResult } from '@apollo/client';
import {
  TradingMainDocument,
  TradingMainQuery
} from '@/modules/common/services/graphql/server/server.sdk';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import {
  trackTransactionClick,
  trackViewAllTransactionsClick,
  trackTransactionsRequestError,
  trackTransactionsRetryClick
} from '@/modules/trade/views/TradeView/trackers';
import { logError } from '@/modules/trade/helpers/logs';

@Component({
  components: {
    HandleSection,
    TransactionsSummaryList
  }
})
export default class TransactionsSection extends Vue {
  isLoading = true;
  hasError = false;
  transactions: TradeMovements[] = [];

  created() {
    this.fetchMovements();
  }

  get hasNewMovementsFF() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.TRADE_NEW_MOVEMENTS);
  }

  get parseTransactions() {
    if (!this.transactions) return [];

    return this.transactions.map(transaction => ({
      ...transaction,
      // @ts-ignore
      type: this.hasNewMovementsFF ? transaction.type : transaction?.detailType,
      date: transaction.date!.formatted,
      description: this.hasNewMovementsFF
        ? transaction.description
        : // @ts-ignore
          transaction.label!.smallDescription
    }));
  }

  async handleOnRetry() {
    trackTransactionsRetryClick();
    await this.fetchMovements();
  }

  private async fetchMovements() {
    this.isLoading = true;
    this.hasError = false;

    try {
      if (this.hasNewMovementsFF) {
        const { movements } = await getMovements();
        this.transactions = movements;
      } else {
        await this.fetchMainDocument();
      }
    } catch (error) {
      logError(error, 'request_movements_error');
      trackTransactionsRequestError();
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  private async fetchMainDocument() {
    const {
      data: { dataMain }
    }: ApolloQueryResult<TradingMainQuery> = await this.$apollo.query({
      query: TradingMainDocument
    });
    this.transactions = dataMain!.transactions
      ? (dataMain!.transactions!.transactions as unknown as TradeMovements[])
      : [];
  }

  handleTransactionClick() {
    trackTransactionClick();
  }

  handleViewAllTransactions() {
    trackViewAllTransactionsClick();
  }
}
